import { Text, Grid, AspectRatio, VStack } from '@chakra-ui/react'
import Image from 'next/image'
import { useTranslation } from 'next-i18next'

export interface ServiceInfoProps {
  title: string
  paragraph: React.ReactNode
  image: string | StaticImageData
}

function ServiceInfo({
  title,
  paragraph,
  image,
}: ServiceInfoProps): React.ReactElement {
  const { t } = useTranslation('services')

  return (
    <Grid
      layerStyle="container"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'gray.300',
        gridGap: { base: '60px', md: 8 },
        alignItems: 'center',
        gridTemplateColumns: {
          base: '1fr',
          md: '1fr 1fr',
        },
        gridAutoFlow: 'row dense',
      }}
    >
      <AspectRatio
        ratio={667 / 613}
        sx={{
          gridColumn: { base: 1, md: 2 },
          mr: {
            base: 10,
            sm: 20,
            md: 20,
          },
          ml: {
            base: 10,
            sm: 20,
            md: 0,
          },
        }}
      >
        <Image
          src={image}
          alt=""
          layout="fill"
          objectFit="contain"
          placeholder="blur"
        />
      </AspectRatio>
      <VStack
        spacing={{
          base: 4,
          sm: 6,
        }}
        sx={{
          alignItems: { base: 'center', md: 'flex-start' },
          textAlign: { base: 'center', md: 'left' },
        }}
      >
        <Text
          as="h1"
          sx={{
            fontSize: { base: '2xl', sm: '4xl' },
            flex: '1 1 auto',
            w: 'full',
            lineHeight: '1em',
          }}
        >
          {t('common.service')}
          <br />
          <Text as="strong">{title}</Text>
        </Text>
        <Text
          as="h1"
          sx={{
            fontSize: { base: 'lg', sm: '2xl' },
            flex: '1 1 auto',
            w: 'full',
          }}
        >
          {paragraph}
        </Text>
      </VStack>
    </Grid>
  )
}

export default ServiceInfo
